<div fxLayout="row wrap" fxLayoutGap="10px">
  <!--  <div class="property" *ngFor="let property of properties">-->
  <!--    {{property.id}}-->
  <!--    <mat-checkbox style="position: absolute; top: 5px; left: 5px"></mat-checkbox>-->
  <!--  </div>-->
  <div *ngIf="dataSourceForMatrix.length > 0"
    style=" padding: 20px 0 0 20px; display: flex; flex-direction: column; margin-top: 20px; background-color: rgba(195, 201, 209, 0.22); max-height: 1000px; overflow-y: scroll; width: 100%">
    <div style="margin-bottom: 5px">Level</div>
    <div *ngFor="let level of dataSourceForMatrix" style="display: flex; align-items: center; margin-bottom: 5px">
      <div style="width: 80px; margin-right: 5px">{{transformLevel(level.level)}}</div>
      <div style="display: flex; overflow-x: scroll">
        <div *ngFor="let property of level.properties"
          style="position: relative; margin-right: 5px; cursor: pointer; font-size: 10px; display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 10px; width: 80px; height: 80px"
          [ngClass]="{'green': property.status === 1, 'red': property.status === 6, 'black': property.status === 5 ||  property.status === 4 ||  property.status === 3 ||  property.status === 2, 'grey': property.status === 0}">
          <p style="margin: 2px auto">{{property.unitNum}}</p>
          <p style="margin: 2px auto">{{property.bedRoom}} BRM</p>
          <p style="margin: 2px auto">{{property.bathRoom}} BTR</p>
          <p style="margin: 2px auto">{{property.carParking}} CAR</p>
          <p style="margin: 2px auto">{{property.price | currency}}</p>
          <mat-checkbox [checked]="isCheckBoxSelected(property.id)" style="position: absolute; top: 5px; right: 5px" (change)="select($event, property.id)"></mat-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>